import { Injectable, EventEmitter } from '@angular/core';
import { UserDto } from '../model/account/UserDto';
import { CookiesStorage } from './core/cookies-storage.service';
@Injectable({
  providedIn: 'root'
})

export class UserProfileService {

  constructor() { }

  setProfile(UserProfileModel: UserDto) {
    CookiesStorage.setCookie('id', UserProfileModel.id);
    CookiesStorage.setCookie('userName', UserProfileModel.userName);
    CookiesStorage.setCookie('accessToken', UserProfileModel.access_token);
    CookiesStorage.setCookie('firstName', UserProfileModel.firstName);
    CookiesStorage.setCookie('lastName', UserProfileModel.lastName);
    CookiesStorage.setCookie('photoUrl', UserProfileModel.photoUrl);
    CookiesStorage.setCookie('companyName', UserProfileModel.companyName);
    CookiesStorage.setCookie('emiratesId', UserProfileModel.emiratesId);
    CookiesStorage.setCookie('cityName', UserProfileModel.cityName);
    CookiesStorage.setCookie('countryName', UserProfileModel.countryName);
    CookiesStorage.setCookie('userTypeId', UserProfileModel.userTypeId);
    CookiesStorage.setCookie('email', UserProfileModel.userName);
    CookiesStorage.setCookie('emailConfirmed', UserProfileModel.emailConfirmed.toString());
    CookiesStorage.setCookie('phoneNumber', UserProfileModel.phoneNumber);
    CookiesStorage.setCookie('phoneNumberConfirmed', UserProfileModel.phoneNumberConfirmed.toString());
    CookiesStorage.setCookie('isSigned', UserProfileModel.isSigned.toString());
    CookiesStorage.setCookie('loginDate', new Date().toString());
    CookiesStorage.setCookie('tokenExpiryDate', (new Date(UserProfileModel.expiration)).getTime().toString());
    CookiesStorage.setCookie('userRoles', JSON.stringify(UserProfileModel.userRoles));
    CookiesStorage.setCookie('defaultLanguage', UserProfileModel.defaultLanguage);
    CookiesStorage.setCookie('legalName', UserProfileModel.legalName);
    CookiesStorage.setCookie('enableDefaultDiscount', UserProfileModel.enableDefaultDiscount);
    CookiesStorage.setCookie('defaultDiscountPercentage', UserProfileModel.defaultDiscountPercentage);
    localStorage.setItem('digitalSignature', UserProfileModel.digitalSignature)

    var that = this;
    setTimeout(function () {
      that.emitUserChangeEvent();
    }, 1000);


  };

  getProfile(): UserDto {
    let profile: UserDto = new UserDto();
    profile.isLoggedIn = CookiesStorage.getCookie('accessToken') != null;
    profile.userName = CookiesStorage.getCookie('userName');
    profile.id = +CookiesStorage.getCookie('id');// + for convert to number
    profile.userTypeId = +CookiesStorage.getCookie('userTypeId');// + for convert to number
    profile.access_token = CookiesStorage.getCookie('accessToken');
    profile.firstName = CookiesStorage.getCookie('firstName');
    profile.companyName = CookiesStorage.getCookie('companyName');
    profile.cityName = CookiesStorage.getCookie('cityName');
    profile.emiratesId = CookiesStorage.getCookie('emiratesId');
    profile.countryName = CookiesStorage.getCookie('countryName');
    profile.lastName = CookiesStorage.getCookie('lastName');
    profile.photoUrl = CookiesStorage.getCookie('photoUrl');
    profile.email = CookiesStorage.getCookie("email");
    profile.emailConfirmed = CookiesStorage.getCookie('emailConfirmed') === "true" ? true : false;
    profile.isSigned = CookiesStorage.getCookie('isSigned') === "true" ? true : false;
    profile.phoneNumber = CookiesStorage.getCookie('phoneNumber');
    profile.phoneNumberConfirmed = CookiesStorage.getCookie('phoneNumberConfirmed') === "true" ? true : false;
    profile.defaultDiscountPercentage = +CookiesStorage.getCookie('defaultDiscountPercentage');// + for convert to number
    profile.enableDefaultDiscount = CookiesStorage.getCookie('enableDefaultDiscount') === "true" ? true : false;
    profile.expiration = CookiesStorage.getCookie('tokenExpiryDate');
    profile.userRoles = JSON.parse(CookiesStorage.getCookie('userRoles'));
    profile.defaultLanguage = CookiesStorage.getCookie('defaultLanguage');
    profile.legalName = CookiesStorage.getCookie('legalName');
    profile.digitalSignature = localStorage.getItem('digitalSignature');

    return profile;
  }

  isOnlyRoleExists(roleId: number): boolean {
    var profile = this.getProfile();

    if (!profile || profile === null || !profile.isLoggedIn) {
      return false;
    }

    if (profile.userRoles === null || profile.userRoles.length === 0) {
      return false;
    }
    if (profile.userRoles.filter(f => f.roleId === roleId).length > 0 && profile.userRoles.filter(f => f.roleId !== roleId).length === 0)
      return true;

    return false;
  }

  isRoleExists(roleId: number): boolean {
    var profile = this.getProfile();

    if (!profile || profile === null || !profile.isLoggedIn) {
      return false;
    }

    if (profile.userRoles === null || profile.userRoles.length === 0) {
      return false;
    }
    if (profile.userRoles.filter(f => f.roleId === roleId).length > 0)
      return true;

    return false;
  }

  setUserProfile(UserProfileModel: UserDto) {
    CookiesStorage.setCookie('firstName', UserProfileModel.firstName);
    CookiesStorage.setCookie('lastName', UserProfileModel.lastName);
    CookiesStorage.setCookie('phoneNumber', UserProfileModel.phoneNumber);
    CookiesStorage.setCookie('companyName', UserProfileModel.companyName);
    CookiesStorage.setCookie('cityName', UserProfileModel.cityName);
    CookiesStorage.setCookie('countryName', UserProfileModel.countryName);
    CookiesStorage.setCookie('defaultLanguage', UserProfileModel.defaultLanguage);
    CookiesStorage.setCookie('photoUrl', UserProfileModel.photoUrl);
    CookiesStorage.setCookie('emiratesId', UserProfileModel.emiratesId);
    CookiesStorage.setCookie('legalName', UserProfileModel.legalName);
    CookiesStorage.setCookie('isSigned', UserProfileModel.isSigned.toString());
    CookiesStorage.setCookie('userRoles', JSON.stringify(UserProfileModel.userRoles));
    localStorage.setItem("digitalSignature", UserProfileModel.digitalSignature);
    var that = this;
    setTimeout(function () {
      that.emitUserChangeEvent();
    }, 1000);
  };

  getProfilebyKey(key: string) {
    return CookiesStorage.getCookie(key) != null ? CookiesStorage.getCookie(key) : null;
  }

  clearProfile() {
    CookiesStorage.setCookie('id', null);
    CookiesStorage.setCookie('userName', null);
    CookiesStorage.setCookie('accessToken', null);
    CookiesStorage.setCookie('firstName', null);
    CookiesStorage.setCookie('lastName', null);
    CookiesStorage.setCookie('email', null);
    CookiesStorage.setCookie('emailConfirmed', null);
    CookiesStorage.setCookie('phoneNumber', null);
    CookiesStorage.setCookie('phoneNumberConfirmed', null);
    CookiesStorage.setCookie('isSigned', null);
    CookiesStorage.setCookie('photoUrl', null);
    CookiesStorage.setCookie('companyName', null);
    CookiesStorage.setCookie('emiratesId', null);
    CookiesStorage.setCookie('cityName', null);
    CookiesStorage.setCookie('countryName', null);
    CookiesStorage.setCookie('userTypeId', null);
    CookiesStorage.setCookie('lastLoginDate', null);
    CookiesStorage.setCookie('loginDate', null);
    CookiesStorage.setCookie('tokenExpiryDate', null);
    CookiesStorage.setCookie('defaultLanguage', null);
    CookiesStorage.setCookie('legalName', null);
    CookiesStorage.setCookie('enableDefaultDiscount', null);
    CookiesStorage.setCookie('defaultDiscountPercentage', null);
    localStorage.removeItem("digitalSignature")
    localStorage.removeItem("NotificationToken")
    CookiesStorage.deleteAllCookies();
    var that = this;
    setTimeout(function () {
      that.emitUserChangeEvent();
    }, 1000);
  }


  userchange: EventEmitter<UserDto> = new EventEmitter();
  emitUserChangeEvent() {
    var UserProfileModel = this.getProfile();
    this.userchange.emit(UserProfileModel);
  }
  getUserChangeEmitter() {
    return this.userchange;
  }


}
